<!-- Content -->
<script src="help-center.component.js"></script>
<div class="container-xxl flex-grow-1 container-p-y" dir="rtl">
    <div class="card overflow-hidden">
      <!-- Help Center Header -->
      <div class="help-center-header d-flex flex-column justify-content-center align-items-center">
        <h3 class="text-center zindex-1 secondary-font">{{'Hello, how can we help you?' | translate}}</h3>
        <div class="input-wrapper my-3 input-group input-group-merge zindex-1">
          <span class="input-group-text" id="basic-addon1"><i class="bx bx-search-alt bx-xs text-muted"></i></span>
          <input type="text" class="form-control form-control-lg" placeholder="{{'Find anything (features, payment or password reset)' | translate}}" aria-label="Search" aria-describedby="basic-addon1">
        </div>
        <p class="text-center zindex-1 px-3 mb-0">
        </p>
      </div>
      <!-- /Help Center Header -->

      <!-- Popular Articles -->
      <div class="help-center-popular-articles py-5">
        <div class="container-xl">
          <h4 class="text-center mt-2 pb-3 secondary-font">{{'Popular Articles' | translate}}</h4>
          <div class="row">
            <div class="col-lg-10 mx-auto">
            <div class="row mb-3">
                <div class="col-md-4 mb-md-0 mb-4">
                  <div class="card border shadow-none all-box">
                    <div class="card-body text-center">
                      <img class="mb-4" src="../../assets/img/icons/unicons/rocket-square.png" height="48" alt="Help center articles">
                      <h5>{{'Beginning' | translate}}</h5>
                      <p class="paragraph">{{'Getting to know the menus' | translate}}</p>
                      <a class="btn btn-label-primary" href="#article">{{'Read more' | translate}}</a>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 mb-md-0 mb-4">
                  <div class="card border shadow-none all-box">
                    <div class="card-body text-center">
                      <img class="mb-4" src="../../assets/img/icons/unicons/cube.png" height="48" alt="Help center articles">
                      <h5>{{'The first steps' | translate}}</h5>
                      <p class="paragraph">{{'From 0 to 100 in the simulation environment' | translate}}</p>
                      <a class="btn btn-label-primary" href="./pages-help-center-article.html">{{'Read more' | translate}}</a>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="card border shadow-none all-box">
                    <div class="card-body text-center">
                      <img class="mb-4" src="../../assets/img/icons/unicons/desktop.png" height="48" alt="Help center articles">
                      <h5>{{'Account' | translate}}</h5>
                      <p class="paragraph">{{'Change settings and personal information' | translate}}</p>
                      <a class="btn btn-label-primary" href="./pages-help-center-article.html">{{'Read more' | translate}}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Popular Articles -->
      <div class="card mb-4">
        <div class="nav-align-left">
          <ul class="nav nav-tabs tabs-line border-end col-xl-2 col-lg-4 col-md-4" role="tablist">
            <li class="nav-item my-2">
              <button type="button" class="nav-link active text-center" role="tab" data-bs-toggle="tab" data-bs-target="#navs-tabs-line-left-home" aria-controls="navs-tabs-line-left-home" aria-selected="true">
                Home
              </button>
            </li>
            <li class="nav-item my-2">
              <button type="button" class="nav-link text-center" role="tab" data-bs-toggle="tab" data-bs-target="#navs-tabs-line-left-profile" aria-controls="navs-tabs-line-left-profile" aria-selected="false">
                Administration
              </button>
            </li>
            <li class="nav-item my-2">
              <button type="button" class="nav-link text-center" role="tab" data-bs-toggle="tab" data-bs-target="#navs-tabs-line-left-messages" aria-controls="navs-tabs-line-left-messages" aria-selected="false">
                Carriers
              </button>
            </li>
            <li class="nav-item my-2">
              <button type="button" class="nav-link text-center" role="tab" data-bs-toggle="tab" data-bs-target="#navs-tabs-line-left-home" aria-controls="navs-tabs-line-left-home" aria-selected="true">
                Finance
              </button>
            </li>
            <li class="nav-item my-2">
              <button type="button" class="nav-link text-center" role="tab" data-bs-toggle="tab" data-bs-target="#navs-tabs-line-left-home" aria-controls="navs-tabs-line-left-home" aria-selected="true">
                Reference books
              </button>
            </li>
            <li class="nav-item my-2">
              <button type="button" class="nav-link text-center" role="tab" data-bs-toggle="tab" data-bs-target="#navs-tabs-line-left-home" aria-controls="navs-tabs-line-left-home" aria-selected="true">
                SMS
              </button>
            </li>
            <li class="nav-item my-2">
              <button type="button" class="nav-link text-center" role="tab" data-bs-toggle="tab" data-bs-target="#navs-tabs-line-left-home" aria-controls="navs-tabs-line-left-home" aria-selected="true">
                Web center
              </button>
            </li>
          </ul>
          <div class="tab-content shadow-none">
            <div class="tab-pane fade active show" id="navs-tabs-line-left-home">
              <div class="col-xl-10 col-lg-8 col-md-8 mx-auto">
                <div class="card overflow-hidden">
                  <div class="card-body">
                    <h4 class="d-flex align-items-center mt-2 mb-4">
                      <span class="badge bg-label-secondary p-2 rounded me-3">
                        <i class="bx bxs-home-circle"></i>
                      </span>
                      {{' Home menu' | translate}}
                    </h4>
                    <p>
                      {{'Lorem Epsom' | translate}}
                    </p>
                    <p>
                      {{'Lorem Epsom' | translate}}
                    </p>
                    <p>
                      {{'Lorem Epsom' | translate}}
                    </p>
                    <div class="d-flex justify-content-between flex-wrap gap-3 my-4">
                      <div class="article-info">
                        <h6 class="mb-1">{{'Was this article helpful?' | translate}}</h6>
                        <p class="card-text">{{'55 people found this article useful' | translate}}</p>
                      </div>
                      <h6>{{'Still need help?' | translate}}<a href="javascript:void(0);">{{'Contact Us' | translate}}</a></h6>
                    </div>
                    <div class="article-votes">
                      <a href="javascript:void(0);" class="badge bg-label-primary me-2 p-2"><i class="bx bx-like"></i></a>
                      <a href="javascript:void(0);" class="badge bg-label-primary p-2"><i class="bx bx-dislike"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="navs-tabs-line-left-profile">
              <div class="col-xl-10 col-lg-8 col-md-8 mx-auto">
                <div class="card overflow-hidden">
                  <div class="card-body">
                    <h4 class="d-flex align-items-center mt-2 mb-4">
                      <span class="badge bg-label-secondary p-2 rounded me-3">
                        <i class="fa fa-screwdriver-wrench"></i>
                      </span>
                      {{' Administration menu' | translate}}
                    </h4>
                    <p>
                      {{'Lorem Epsom' | translate}}
                    </p>
                    <p>
                      {{'Lorem Epsom' | translate}}
                    </p>
                    <p>
                      {{'Lorem Epsom' | translate}}
                    </p>
                    <div class="d-flex justify-content-between flex-wrap gap-3 my-4">
                      <div class="article-info">
                        <h6 class="mb-1">{{'Was this article helpful?' | translate}}</h6>
                        <p class="card-text">{{'55 people found this article useful' | translate}}</p>
                      </div>
                      <h6>{{'Still need help?' | translate}}<a href="javascript:void(0);">{{'Contact Us' | translate}}</a></h6>
                    </div>
                    <div class="article-votes">
                      <a href="javascript:void(0);" class="badge bg-label-primary me-2 p-2"><i class="bx bx-like"></i></a>
                      <a href="javascript:void(0);" class="badge bg-label-primary p-2"><i class="bx bx-dislike"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="navs-tabs-line-left-messages">
              <div class="col-xl-10 col-lg-8 col-md-8 mx-auto">
                <div class="card overflow-hidden">
                  <div class="card-body">
                    <h4 class="d-flex align-items-center mt-2 mb-4">
                      <span class="badge bg-label-secondary p-2 rounded me-3">
                        <i class="fa fa-building"></i>
                      </span>
                      {{' Carriers menu' | translate}}
                    </h4>
                    <p>
                      {{'Lorem Epsom' | translate}}
                    </p>
                    <p>
                      {{'Lorem Epsom' | translate}}
                    </p>
                    <p>
                      {{'Lorem Epsom' | translate}}
                    </p>
                    <div class="d-flex justify-content-between flex-wrap gap-3 my-4">
                      <div class="article-info">
                        <h6 class="mb-1">{{'Was this article helpful?' | translate}}</h6>
                        <p class="card-text">{{'55 people found this article useful' | translate}}</p>
                      </div>
                      <h6>{{'Still need help?' | translate}}<a href="javascript:void(0);">{{'Contact Us' | translate}}</a></h6>
                    </div>
                    <div class="article-votes">
                      <a href="javascript:void(0);" class="badge bg-label-primary me-2 p-2"><i class="bx bx-like"></i></a>
                      <a href="javascript:void(0);" class="badge bg-label-primary p-2"><i class="bx bx-dislike"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Help Area -->
      <div class="help-center-contact-us help-center-bg-alt">
        <div class="container-xl">
          <div class="row justify-content-center py-5 my-3">
            <div class="col-md-8 col-lg-6 text-center">
              <h4 class="secondary-font">{{'Still need help?' | translate}}</h4>
              <p class="mb-4">
                {{'Our experts are always ready to help. with us during hours' | translate}}<br>
                {{' Call the office or send an email at any time and we will contact you.' | translate}}
              </p>
              <div class="d-flex justify-content-center flex-wrap gap-4">
                <a href="javascript:void(0);" class="btn btn-label-primary">{{'Contact Us' | translate}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Help Area -->
    </div>
  </div>
<!--/ Content -->